import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
//MaterialUI
import Box from "@material-ui/core/Box";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import Pagination from "@material-ui/lab/Pagination";

import Tooltip from "@material-ui/core/Tooltip";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import { OPPORTUNITY_CANDIDATE_STATE_KEY, TABLE_STATE_CHIP_COLOR } from "utils/const";
import limitaString from "utils/string_utils";

import componentStylesGeneric from "assets/theme/views/admin/generic";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function OpportunityApplicationsResultSection(props) {
  const theme = useTheme();
  const classes = useStylesGeneric();
  const { setValue, watch } = useFormContext();

  const pageIndex = watch("pageIndex") ?? 1;

  const tableHead = [
    { label: "Nº Candidatura", sortKey: "candidateCode" },
    { label: "Nome", sortKey: "userName" },
    { label: "Nº BI", sortKey: "userIdentityCard" },
    { label: "Nº Oferta", sortKey: "opportunityReference" },
    { label: "Tipo de Oferta", sortKey: "opportunityTitle" },
    { label: "Data de Candidatura", sortKey: "creationDate" },
    { label: "Estado", sortKey: "candidateStateDescription" },
  ];

  const handleSort = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    
    if (props.sortColumn === column) {
      props.setSortDirection(props.sortDirection === "asc" ? "desc" : "asc");
    } else {
      props.setSortColumn(column);
      props.setSortDirection("asc");
    }
    setValue("pageIndex", 1);
  };

  const renderSortIcon = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    if (props.sortColumn === column) {
      return props.sortDirection === "desc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      );
    }
    return <UnfoldMoreIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle", opacity: 0.3 }} />;
  };

  const mapOpportunityCandidateStateToTableChipColors = (stateKey) => {
    switch (stateKey) {
      case OPPORTUNITY_CANDIDATE_STATE_KEY.APROVADA:
        return TABLE_STATE_CHIP_COLOR.GREEN;
      case OPPORTUNITY_CANDIDATE_STATE_KEY.REJEITADA:
        return TABLE_STATE_CHIP_COLOR.RED;
      case OPPORTUNITY_CANDIDATE_STATE_KEY.EMRECRUTAMENTO:
        return TABLE_STATE_CHIP_COLOR.LIGHT_ORANGE;
      case OPPORTUNITY_CANDIDATE_STATE_KEY.DESISTENCIA:
        return TABLE_STATE_CHIP_COLOR.BLUE;
      default:
        return <></>;
    }
  };

  return (
    <>
      {props.opportunitiesState?.userColectiveOpportunityApplications_result?.data?.length > 0 && (
        <CardTableContainer
          title={"Lista de Candidaturas a Emprego e Estágio Profissional"}
          count={props.opportunitiesState?.userColectiveOpportunityApplications_total_records}
        >
          <TableContainer>
            <Box component={Table} alignItems="center" marginBottom="0!important">
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                      }}
                      onClick={() => handleSort(key)}
                      style={{ cursor: "pointer", userSelect: "none" }}
                    >
                      <Box display="flex" alignItems="center">
                        {prop.label}
                        {renderSortIcon(key)}
                      </Box>
                    </TableCell>
                  ))}
                  <TableCell
                    key="detailsCol"
                    classes={{
                      root:
                        classes.tableCellRoot +
                        " " +
                        classes.tableCellRootHead +
                        " " +
                        classes.tableCellHeadStickyRight,
                    }}
                  >
                    Detalhes
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.opportunitiesState.userColectiveOpportunityApplications_result.data.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }} title={prop.title ?? ""}>
                      <Box>{prop.candidateCode}</Box>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.userName}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.userIdentityCard}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.opportunityReference}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }} title={prop.title ?? ""}>
                      <Box fontWeight={"bold"}>{prop.opportunityTypeDescription}</Box>
                      <Box>{limitaString(prop.opportunityTitle, 60)}</Box>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      <Box>{prop.creationDate}</Box>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      <TableStateChip
                        state={mapOpportunityCandidateStateToTableChipColors(prop.candidateStateKey)}
                        message={prop.candidateStateDescription}
                      />
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                      <Tooltip title="Detalhes">
                        <IconButton
                          aria-label="details"
                          component={Link}
                          to={`/admin/candidate-details/${prop.candidateCode}`}
                        >
                          <Box
                            component={ArrowForwardIosIcon}
                            width="12px!important"
                            height="12px!important"
                            color={theme.palette.primary.main}
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
            <TableBackdrop open={props.opportunitiesState?.getUserColectiveOpportunityApplications_loading} />
          </TableContainer>

          <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end"></Box>

          <Pagination
            className={classes.alignPagination}
            count={props.opportunitiesState?.userColectiveOpportunityApplications_total_pages}
            page={pageIndex}
            onChange={(_, value) => {
              setValue("pageIndex", value);
            }}
            color="primary"
          ></Pagination>
        </CardTableContainer>
      )}
      {props.opportunitiesState?.userColectiveOpportunityApplications_result?.data?.length === 0 && (
        <Box classes={{ root: classes.noResultsInfo }}>Não foram encontrados resultados para esta pesquisa.</Box>
      )}
    </>
  );
}
const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityApplicationsResultSection);
